import { render, staticRenderFns } from "./PackageHistoryPanel.vue?vue&type=template&id=a264a590"
import script from "./PackageHistoryPanel.vue?vue&type=script&lang=js"
export * from "./PackageHistoryPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports